import settings from "settings";

type LockOptions = {
  /** Key to use for the lock. */
  key: string;
  /** Upper bound for how long the lock will be held. */
  timeoutMs?: number;
};

/** Runs something with a given key once-per-browser. */
export class RunnerWithLock {
  id: string;

  constructor() {
    this.id = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
  }

  private getLocker(key: string) {
    const value = localStorage.getItem(key);
    if (!value) {
      return null;
    }
    const [locker, timestamp] = value.split(":");
    if (Number(timestamp) < Date.now()) {
      return null;
    }
    return locker;
  }

  async run(opts: LockOptions, func: () => Promise<void>) {
    const mutexKey = `${settings.browserStoragePrefix}__lock_${opts.key}`;

    if (
      this.getLocker(mutexKey) !== null &&
      this.getLocker(mutexKey) !== this.id
    ) {
      return false;
    }

    localStorage.setItem(
      mutexKey,
      `${this.id}:${Date.now() + (opts.timeoutMs ?? 5000)}`
    );

    try {
      await func();
      return true;
    } finally {
      localStorage.removeItem(mutexKey);
    }
  }
}
